/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getHospitals = (payload = {}, callback) =>
  req.list(
    c.GET_HOSPITALS,
    '/api/v1/administrators/hospitals',
    payload,
    callback
  );

export const getCitizenshipList = (name, payload, callback) =>
  req.list(
    `${c.GET_CITIZENSHIP}/${name}`,
    '/api/v1/administrators/citizenship',
    payload,
    callback
  );

export const getAssessmentFeeList = (
  transactionHistoryId,
  payload = {},
  callback
) =>
  req.list(
    c.GET_ASSESSMENT_FEES,
    `/api/v1/administrators/transaction_histories/${transactionHistoryId}/assessment_fees`,
    payload,
    callback
  );

export const updateAssessmentFee = (
  transactionHistoryId,
  type,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_ASSESSMENT_FEES,
    `/api/v1/administrators/transaction_histories/${type}_certificates/${transactionHistoryId}/update_fees`,
    payload,
    callback
  );
